import * as API from './api'
import * as Types from './Types'

export function tryCreateUser(token, communityId, apartmentId, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_USER
    })

    API.createUser(token, communityId, apartmentId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_USER_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.CREATE_USER_FAILED,
          payload: status
        })
      })
  }
}

export function tryDeleteUser(token, communityId, userId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_USER
    })

    API.deleteUser(token, communityId, userId)
      .then(() => {
        dispatch({
          type: Types.DELETE_USER_SUCCESS,
          payload: userId
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_USER_FAILED
        })
      })
  }
}

export function tryUpdateUser(token, communityId, userId, postData) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_USER
    })

    API.updateUser(token, communityId, userId, postData)
      .then(response => {
        dispatch({
          type: Types.UPDATE_USER_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.UPDATE_USER_FAILED,
          payload: status
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Users.js